export const userMixin = {
  watch: {
    // "user.id": {
    //   immediate: true,
    //   handler(value) {
    //     if (value) {
    //       this.fetchDataWithLoader();
    //     }
    //   }
    // }
  },
  methods: {
    formatUserIdentity(fullName, email) {
      return [fullName, email].filter(Boolean).join(' / ');
    }
  }
};
